import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Objects } from 'src/modules/utils/shared/objects';

export interface DetailListEntry {
    label: string;
    value: any;
}

@Component({
    selector: 'app-detail-list',
    standalone: false,
    templateUrl: './detail-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './detail-list.component.scss'
})
export class DetailListComponent {

    @Input()
    title = '';

    @Input()
    entries: DetailListEntry[] | null = [];

    @Input()
    emptyText = '';

    formatDetailValue(value: any): string {
        if (value == null) {
            return '-';
        }

        if (typeof value === 'string') {
            return value || '-';
        }

        if (typeof value === 'number' || typeof value === 'boolean') {
            return value.toString();
        }

        if (Array.isArray(value)) {
            return value.length > 0 ? value.map(item => this.formatDetailValue(item)).join(', ') : '-';
        }

        if (typeof value === 'object') {
            return Objects.toJson(value);
        }

        return Objects.toJson(value);
    }



}
